import React from 'react'
import './About.scss'

import{motion}  from 'framer-motion';
import {images} from '../../constant'
import{AppWrap,MotionWrap} from '../../wrapper'
let abouts=[
  {
    title:'FrontEnd Developer',
    description:'I am a Innovative and detail-oriented Front End Developer with a passion for creating responsive and user-friendly websites.',
    imgUrl:images.about01
  },
  {
    title:'MERN Stack Developer',
    description:'Also I can build simple backend oriented projects like connect and data send to database.Tech Stack by using Node JS,Express JS,Mongo DB.',
    imgUrl:images.about02
  },
  {
    title:'Web Animation',
    description:'Create attractive web design like Nav Animation,Scroll Animation etc..By using GSAP and Framer Motion in React.',
    imgUrl:images.about03
  },
  {
    title:'Development Tools',
    description:'Also known as Most popular version management tools like Git and GitHub.Code written tools like Visual Studio Code (VSC).',
    imgUrl:images.about04
  },
]
function About() {
  return (
  <div>
  <h2 className='head-text'>I Know That <span> Good Apps</span><br/> Means <span>Good Business</span> </h2>

  <div className='app__profiles'>
    {abouts.map((about,index)=>(
     <motion.div
     whileInView={{opacity:1}}
     whileHover={{scale:1.1}}
     transition={{duration:0.5, type:'tween'}}
     className='app__profile-item'
     key={about.title+index}
     >
     <img src={about.imgUrl} alt={about.title}/>
     <h2 className='bold-text' style={{marginTop:20}}>{about.title}</h2>
     <p className='p-text' style={{marginTop:10}}>{about.description}</p>
     
     </motion.div>
  ))}
  </div>


  </div>
  )
}

export default AppWrap(
  MotionWrap(About,'app__about'),'about','app__whitebg');
